import { type LinkProps, Link as MUILink } from '@mui/material';
import { memo, type PropsWithChildren } from 'react';
import { SectionName } from './SectionName';

type Props = PropsWithChildren<
  LinkProps & {
    handleRef?: (ref: HTMLAnchorElement | null, headingId: string) => void;
    headingId: string;
    isSelected: boolean;
  }
>;

export const Link = memo(({ handleRef, headingId, isSelected, children, ...rest }: Props) => {
  return (
    <MUILink
      key={headingId}
      href={`#${headingId}`}
      underline="none"
      {...(handleRef && {
        ref: (ref: HTMLAnchorElement | null) => handleRef(ref, headingId),
      })}
      sx={{
        display: 'flex',
        color: 'black',
        paddingY: 2,
        paddingLeft: 3,
        paddingRight: 2,
        borderLeft: '4px solid',
        borderLeftColor: 'transparent',
        '&:active': {
          outline: '2px solid',
          outlineOffset: '-1px',
          outlineColor: 'secondary.main',
          outlineStyle: 'auto',
        },
        '&.selected': {
          backgroundColor: 'blues.lightest',
          borderLeftColor: 'primary.main',
        },
        '&:hover': {
          backgroundColor: 'neutral.lightest',
          borderLeftColor: 'primary.main',
        },
        '&:focus-visible': {
          backgroundColor: 'blues.lightest',
          borderLeftColor: 'primary.main',
        },
      }}
      {...rest}
    >
      <SectionName bold={isSelected}>{children}</SectionName>
    </MUILink>
  );
});
